globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.FloatingMenu = (function() {
    function FloatingMenu($html) {
      this.$html = $html;
      this.init();
    }

    FloatingMenu.prototype = {
      init : function() {
        if (window.matchMedia('(min-width: 992px)').matches) {
          this.toggleInfo();
          this.copyInfo();
        }
      },

      toggleInfo: function() {
        this.$html.on('click', '.floating-menu-link.toggle-link', function(e) {
          e.preventDefault();

          var $link = $(this);
          var $toggleInfo = $link.closest('.floating-menu-link-wrapper').find('.toggle-info');

          if (!$toggleInfo.length) return;

          if ($toggleInfo.data('animating')) return;

          $toggleInfo.data('animating', true);

          if ($toggleInfo.is(':visible')) {
            $toggleInfo.fadeOut(200, function() {
              $toggleInfo.data('animating', false);
              $link.tooltip('open');
            });
          } else {
            $toggleInfo.fadeIn(200, function() {
              $toggleInfo.data('animating', false);
              $link.tooltip('close');
            });
          }
        });
      },

      copyInfo: function() {
        var clipboards = new Clipboard('.clipboard');

        clipboards.on('success', function(e) {
          var $trigger = $(e.trigger);

          if (!$trigger.data('ui-tooltip')) {
            $trigger.tooltip({ content: 'Copié !', show: null, hide: { effect: "fade", duration: 200 } });
          }

          $trigger.tooltip('option', 'content', 'Copié !');
          $trigger.tooltip('open');

        });
      }
    }

  return FloatingMenu;
})();
